import React, { useState, useEffect, useRef } from 'react';
import { Box, Button, Grid, Breadcrumbs, Link, Tooltip, Typography, Select, MenuItem, TextField, FormControl, InputLabel } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { getRoomMaster, getRoomMasterData, getdrpRoomView } from '../../../../Api/RoomMst/Api';
import { getRoomMasterdropdata, GetBedCalendarMonthwise, GetPropWiseBedCalendarMonth, updatebedcalender } from '../../../../Api/PropertyMst/Api'
import { useLocation } from "react-router-dom";
import { toast } from 'react-toastify';
import { getFormMode } from "../../../../lib/helpers";
import TableComponent from "../../../../atoms/TableComponent/DataTableBedCalender";
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
// import { useSelector } from 'react-redux';
import { selectCurrentModulePermissions } from '../../../../redux/permissionsSlice';
import { usePermissions } from '../../../../GlobalFunction/userPermissions';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';
import CrudButtons from '../../../../GlobalFunction/CrudButtons'
import axiosInstance from '../../../../lib/axios';
import {
  Edit as EditIcon,
  Save
} from '@mui/icons-material';
import { Delete as DeleteIcon } from '@mui/icons-material'
import { useDispatch, useSelector } from 'react-redux';
import {
  selectProperties,
  selectGlobalProperty,
  selectLocalProperty,
  setLocalProperty,
  fetchProperties,
  selectPropertyStatus
} from '../../../../redux/propertySlice';

const Form_Mode = getFormMode();

const MONTHS = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'
]

const BASE_COLUMNS = [
  { id: 'RoomNo', label: 'RoomNo', minWidth: 60 },
  { id: 'RoombedName', label: 'BedNo', minWidth: 60 },
  { id: 'RoomTypeName', label: 'RType', minWidth: 100 },
  { id: 'RoomBedTypeName', label: 'BType', minWidth: 100 },
  { id: 'RoomViewNAme', label: 'View', minWidth: 100 },
  { id: 'FloorName', label: 'Floor', minWidth: 70 },
];

const generateColumns = (startDate, endDate) => {
  const baseColumnWidths = {
    RoomNo: 60,
    RoombedName: 60,
    RoomTypeName: 100,
    RoomBedTypeName: 100,
    RoomViewNAme: 100,
    FloorName: 70,
  };

  const baseColumns = BASE_COLUMNS.map(col => ({
    ...col,
    minWidth: baseColumnWidths[col.id],
    maxWidth: baseColumnWidths[col.id],
    width: baseColumnWidths[col.id]
  }));

  // Generate array of months between start and end date
  const columns = [];
  let currentDate = dayjs(startDate).startOf('month');
  const endMonth = dayjs(endDate).endOf('month');

  while (currentDate.isBefore(endMonth) || currentDate.isSame(endMonth, 'month')) {
    const year = currentDate.year();
    const month = MONTHS[currentDate.month()];

    // Add year column if it's January or the first month in range
    if (currentDate.month() === 0 || currentDate.isSame(startDate, 'month')) {
      columns.push({
        id: `year_${year}`,
        label: 'Year',
        minWidth: 45,
        maxWidth: 45,
        width: 45
      });
    }

    columns.push({
      id: `${year}_${month}`,
      label: month.substring(0, 3),
      minWidth: 45,
      maxWidth: 45,
      width: 45
    });

    currentDate = currentDate.add(1, 'month');
  }

  return [...baseColumns, ...columns];
};

const transformData = (apiData, startDate, endDate) => {
  const roomDataMap = new Map();

  // First pass: Organize data by RoomBedId
  apiData.forEach(item => {
    if (!roomDataMap.has(item.RoomBedId)) {
      roomDataMap.set(item.RoomBedId, {
        RoomBedId: item.RoomBedId,
        RoomNo: item.RoomNo,
        RoombedName: item.RoombedName,
        RoomTypeName: item.RoomTypeName,
        RoomBedTypeName: item.RoomBedTypeName,
        RoomViewNAme: item.RoomViewNAme,
        FloorName: item.FloorName,
        ResidentName: item.BookingDetails?.ResidentName || item.ResidentName,
        BookNo: item.BookingDetails?.BookNo || item.BookNo,
        bookings: [],
      });
    }

    const roomData = roomDataMap.get(item.RoomBedId);
   roomData.bookings.push({
      YearNm: item.YearNm,
      MonthId: item.MonthId,
      MonthNm: item.MonthNm,
      BedStatus: item.BedStatus,
      ResidentName: item.BookingDetails?.ResidentName || item.ResidentName,
      BookNo: item.BookingDetails?.BookNo || item.BookNo
    });

    const monthKey = `${item.YearNm}_${MONTHS[item.MonthId - 1]}`;
    roomData[monthKey] = item.BedStatus;

    const yearKey = `year_${item.YearNm}`;
    roomData[yearKey] = item.YearNm;
  });

  // Convert Map to array and ensure all required columns exist
  const transformedData = Array.from(roomDataMap.values()).map(roomData => {
    const row = { ...roomData };

    // Fill in data for the selected date range
    let currentDate = dayjs(startDate).startOf('month');
    const endMonth = dayjs(endDate).endOf('month');

    while (currentDate.isBefore(endMonth) || currentDate.isSame(endMonth, 'month')) {
      const year = currentDate.year();
      const month = MONTHS[currentDate.month()];

      // Add year column if it's January or first month
      if (currentDate.month() === 0 || currentDate.isSame(startDate, 'month')) {
        const yearKey = `year_${year}`;
        if (!row[yearKey]) {
          row[yearKey] = year;
        }
      }

      // Ensure month column exists
      const monthKey = `${year}_${month}`;
      if (!row[monthKey]) {
        row[monthKey] = '';
      }

      currentDate = currentDate.add(1, 'month');
    }

    return row;
  });

  return transformedData;
};

export default function GenerateCalender(PropId, formMode) {
  const userId = sessionStorage.getItem('UserId');
  const location = useLocation();
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [searchTerms, setSearchTerms] = useState({});
  const [rows, setRows] = useState([]);
  const [dropdownData, setDropdownData] = useState([]);
  // const [properties, setProperties] = useState([]);
  const [selectedValue, setSelectedValue] = useState('');
  const [selectedPropId, setSelectedPropId] = useState(null);
  const [dateFrom, setDateFrom] = useState(dayjs());
  const [dateTo, setDateTo] = useState(dayjs().add(12, 'months'));
  const [tableColumns, setTableColumns] = useState(generateColumns([dayjs().year()]));
  const [isLoading, setIsLoading] = useState(false);
  const [editableData, setEditableData] = useState(new Map());
  const [selectedRoomBedIds, setSelectedRoomBedIds] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [pagination, setPagination] = useState({
    totalRecords: 0,
    currentPage: 1,
    totalPages: 0,
    pageSize: 1000
  });
  const [form, setForm] = useState({
    PropId: "",
  });
  const dispatch = useDispatch();
  const properties = useSelector(selectProperties);
  const globalProperty = useSelector(selectGlobalProperty);
  const localProperty = useSelector(state => selectLocalProperty(state, 'calendar'));
  const propertyStatus = useSelector(selectPropertyStatus);
  const selectedProperty = localProperty || globalProperty;
  const [mode, setMode] = useState(() =>
    location?.state?.RoomId ? Form_Mode.read : Form_Mode.add
  );
  const permissions = usePermissions("Generate Calender");

  const handleCellEdit = (roomBedId, columnId, newValue, originalValue) => {
    if (!isEditMode || !selectedRoomBedIds.includes(roomBedId)) return;

    const row = rows.find(r => r.RoomBedId === roomBedId);
    if (!row) return;

    const [year, month] = columnId.split('_');

    // Allow empty string while maintaining the original background color
    if (newValue === '') {
      const monthIndex = MONTHS.findIndex(m => m === month) + 1;
      const key = `${roomBedId}-${columnId}`;

      setEditableData(prev => {
        const newMap = new Map(prev);
        newMap.set(key, {
          RoomBedId: roomBedId,
          MonthNm: month,
          MonthId: monthIndex,
          YearNm: parseInt(year),
          BedStatus: newValue,
          originalValue: originalValue,
          CreatedBy: parseInt(sessionStorage.getItem('UserId') || '0'),
          originalValue: originalValue,
          PropId: selectedProperty, // Add PropId here
        });
        return newMap;
      });

      setRows(prevRows => {
        return prevRows.map(r => {
          if (r.RoomBedId === roomBedId) {
            return {
              ...r,
              [columnId]: newValue,
              [`${columnId}_original`]: originalValue
            };
          }
          return r;
        });
      });
      return;
    }

    // Validate new value if not empty
    if (newValue !== '' && !['A', 'M', 'R'].includes(newValue.toUpperCase())) {
      toast.error('Only A, M, or R values are allowed');
      return;
    }

    const monthIndex = MONTHS.findIndex(m => m === month) + 1;
    const key = `${roomBedId}-${columnId}`;

    setEditableData(prev => {
      const newMap = new Map(prev);
      newMap.set(key, {
        RoomBedId: roomBedId,
        MonthNm: month,
        MonthId: monthIndex,
        YearNm: parseInt(year),
        BedStatus: newValue.toUpperCase(),
        CreatedBy: parseInt(sessionStorage.getItem('UserId') || '0'),
        PropId: selectedProperty // Add PropId here
      });
      return newMap;
    });

    setRows(prevRows => {
      return prevRows.map(r => {
        if (r.RoomBedId === roomBedId) {
          return {
            ...r,
            [columnId]: newValue.toUpperCase()
          };
        }
        return r;
      });
    });
  };

  const handleSave = async () => {
    const updateData = Array.from(editableData.values());

    if (updateData.length === 0) {
      toast.warn('No changes to save');
      return;
    }

    try {
      const payload = {
        BedCalendarConfig: updateData
      };

      let json = JSON.stringify(payload);
      json = json
        .replace(/\\/g, "\\\\")
        .replace(/"/g, '\\"');
      json = '"' + json + '"';

      const response = await updatebedcalender(json);

      if (response?.data?.Status === 0) {
        // Prepare payloads for the additional APIs
        const propId = updateData[0]?.PropId; // Assuming PropId is available in updateData
        const roomBedId = updateData[0]?.RoomBedId; // Assuming RoomBedId is available

        const bedCatPayload = {
          PropId: propId,
          Flag: ""
        };

        const bedCatCalPayload = {
          PropId: propId,
          RoomBedId: roomBedId,
          Flag: ""
        };

        try {
          // Call all 4 additional APIs after successful save
          // await axiosInstance.post(`BedCalendar/InsertBedCat`, bedCatPayload);
          // await axiosInstance.post(`BedCalendar/InsertBedCatCal`,bedCatCalPayload);
          // await axiosInstance.post(`BedCalendar/UpdateBedCat`,bedCatPayload);
          // await axiosInstance.post(`BedCalendar/UpdateBedCatCal`,bedCatCalPayload);

          // Run all 4 additional API calls in parallel
          await Promise.all([
            axiosInstance.post('BedCalendar/InsertBedCat', bedCatPayload),
            axiosInstance.post('BedCalendar/InsertBedCatCal', bedCatCalPayload),
            axiosInstance.post('BedCalendar/UpdateBedCat', bedCatPayload),
            axiosInstance.post('BedCalendar/UpdateBedCatCal', bedCatCalPayload)
          ]);
          toast.success('Changes saved and all related data updated successfully.');
        } catch (apiError) {
          toast.warning('Changes saved but some updates failed');
        }
        setIsEditMode(false);
        setEditableData(new Map());
        setSelectedRoomBedIds([]);
        await fetchData("");
      } else {
        toast.error(response?.data?.Message || 'Failed to save changes');
      }
    } catch (error) {
      toast.error('Error saving changes: ' + (error.message || 'Unknown error'));
    }
  };

  const handleDeleteSelected = async () => {
    if (!window.confirm('Are you sure you want to delete the selected records?')) {
      return;
    }

    try {
      setIsLoading(true);

      // Format dates to match your required format (YYYY-MM-DD)
      const formattedDateFrom = dateFrom.format("YYYY-MM-DD");
      const formattedDateTo = dateTo.format("YYYY-MM-DD");

      const deletePayload = {
        BedCalendarConfig: selectedRoomBedIds.map(roomBedId => {
          const editData = Array.from(editableData.entries()).find(([key]) => key.startsWith(`${roomBedId}-`));
          const propId = editData ? editData[1].PropId : selectedProperty; // Fallback to selectedProperty
          return {
            RoomBedId: roomBedId,
            DBFLAG: "D",
            BookDtFrom: formattedDateFrom,
            CheckoutDt: formattedDateTo,
            PropId: propId // Add PropId
          };
        })
      };

      // Stringify the payload with proper escaping
      let json = JSON.stringify(deletePayload);
      json = json
        .replace(/\\/g, "\\\\")
        .replace(/"/g, '\\"');
      json = '"' + json + '"';

      const response = await updatebedcalender(json);

      if (response?.data?.Status === 0) {
        toast.success('Records deleted successfully');
        setSelectedRoomBedIds([]);
        await fetchData("");
      } else {
        toast.error(response?.data?.Message || 'Failed to delete records');
      }
    } catch (error) {
      toast.error('Error deleting records: ' + (error.message || 'Unknown error'));
    } finally {
      setIsLoading(false);
    }
  };

  const handleDropdownChange = async (event) => {
    const selectedId = event.target.value;
    dispatch(setLocalProperty({
      componentId: 'calendar',
      propertyId: selectedId
    }));
    setForm(prevForm => ({
      ...prevForm,
      PropId: selectedId
    }));

    setIsEditMode(false);
    setSelectedRoomBedIds([]);
    setEditableData(new Map());

    if (!dateFrom || !dateTo) {
      return toast.error("Please select a date range");
    }

    try {
      setIsLoading(true);
      setRows([]);

      const payload = {
        PropId: selectedId,
        BookDtFrom: dateFrom.format("YYYY-MM-DD"),
        CheckoutDt: dateTo.format("YYYY-MM-DD"),
      };

      // const response = await GetPropWiseBedCalendarMonth(payload);

      // if (response?.data?.Status === 0) {
      //   const newColumns = generateColumns(dateFrom, dateTo);
      //   setTableColumns(newColumns);
      //   const transformedData = transformData(response.data.Data, dateFrom, dateTo);
      //   setRows(transformedData || []);
      // } else {
      //   toast.error(response?.data?.Message || "Error fetching data");
      // }
    } catch (error) {
      toast.error("Failed to fetch data");
      setRows([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = () => {
    setIsEditMode(false);
    setSelectedRoomBedIds([]);
    setEditableData(new Map());
    fetchData("");
  };

  const handldelete = async () => {
    if (!selectedProperty || !dateFrom || !dateTo) {
      return toast.error("Please select a property and date range");
    }

    if (!window.confirm("Are you sure you want to delete this data?")) {
      return;
    }

    try {
      setIsLoading(true);

      const payload = {
        PropId: selectedProperty,
        BookDtFrom: dateFrom.format("YYYY-MM-DD"),
        CheckoutDt: dateTo.format("YYYY-MM-DD"),
        Flag: "D"
      };

      const response = await GetPropWiseBedCalendarMonth(payload);

      if (response?.data?.Status === 0) {
        toast.success("Data deleted successfully");
        setRows([]);
        await fetchData("");
      } else {
        toast.error(response?.data?.Message || "Error deleting data");
      }
    } catch (error) {
      toast.error("Failed to delete data: " + (error.message || "Unknown error"));
    } finally {
      setIsLoading(false);
    }
  };


  const fetchData = async (Flag, page = 1, searchText = "", pageSize = pagination.pageSize || 1000) => {
    // Validate dates before API call
    if (!validateDateRange(dateFrom, dateTo)) {
      return; // Stop execution if validation fails
    }

    if (!selectedProperty) {
      return toast.error("Please select a property");
    }

    try {
      setIsLoading(true);
      setRows([]);

      const payload = {
        PropId: selectedProperty,
        BookDtFrom: dateFrom.format("YYYY-MM-DD"),
        CheckoutDt: dateTo.format("YYYY-MM-DD"),
        Flag,
        currentPage: page,
        PageSize: pageSize,
        SearchText: searchText
      };

      const response = await GetPropWiseBedCalendarMonth(payload);

      if (response?.data?.Status === 0) {
        const newColumns = generateColumns(dateFrom, dateTo);
        setTableColumns(newColumns);

        const transformedData = transformData(response.data.Data, dateFrom, dateTo);
        setRows(transformedData);

        setPagination(prev => ({
          ...prev,
          totalRecords: response.data.PageData?.TotalRecords || 0,
          currentPage: response.data.PageData?.PageNumber || 1,
          totalPages: response.data.PageData?.TotalPages || 1,
          pageSize: pageSize
        }));

      } else {
        toast.error(response?.data?.Message || "Error fetching data");
      }
    } catch (error) {
      toast.error("Failed to fetch data");
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearchChange = (columnId, value) => {
    if (columnId === 'generalSearch') {
      // Clear any existing timeout
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }

      // Only search if at least 3 characters are entered
      if (value.length >= 3 || value.length === 0) {
        searchTimeoutRef.current = setTimeout(() => {
          fetchData("", 1, value);
        }, 1000); // 1000ms delay after typing stops
      }
    } else {
      setSearchTerms(prev => ({ ...prev, [columnId]: value }));
      setPage(0);
    }
  };

  const searchTimeoutRef = useRef(null);

  // Clean up the timeout when component unmounts
  useEffect(() => {
    return () => {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
    };
  }, []);
  // Handle page change
  const handlePageChange = (newPage) => {
    setPagination(prev => ({ ...prev, currentPage: newPage }));
    fetchData("", newPage, "", pagination.pageSize);
  };

  // Handle rows per page change
  const handleRowsPerPageChange = (newPageSize) => {
    setPagination(prev => ({
      ...prev,
      pageSize: newPageSize,
      currentPage: 1 // Reset to first page when changing page size
    }));
    fetchData("", 1, "", newPageSize);
  };

  // Initial data load
  // useEffect(() => {
  //   if (selectedProperty && dateFrom && dateTo) {
  //     fetchData("", 1);
  //   }
  // }, [selectedProperty, dateFrom, dateTo]);

  useEffect(() => {
    // const fetchDropdownData = async () => {
    //   try {
    //     const response = await getRoomMasterdropdata({
    //       Flag: "",
    //       UserId: userId,
    //     });

    //     if (response?.data?.Status === 0) {
    //       const dropdownItems = response.data.Data.map((item) => ({
    //         id: item.PropId,
    //         name: item.Name,
    //       }));
    //       setDropdownData(dropdownItems);
    //       if (dropdownItems.length > 0) {
    //         setSelectedValue(dropdownItems[0].id);
    //       } else {
    //         setDropdownData([]);
    //         setRows([]);
    //         toast.info("No properties available");
    //       }
    //     }
    //   } catch (error) {
    //     toast.error("Error fetching property data");
    //   }
    // };

    // fetchDropdownData();
  }, [userId]);

  const getMonthStyle = (value) => {
    switch (value) {
      case "V":
        return { backgroundColor: "green", color: "white" };
      case "B":
        return { backgroundColor: "red", color: "white" };
      case "O":
        return { backgroundColor: "yellow", color: "black" };
      case "A":
        return { backgroundColor: "#006400", color: "white" };
      case "C":
        return { backgroundColor: "#ff1a1a", color: "white" };
      default:
        return {};
    }
  };

  const handleDateFromChange = (newDate) => {
    setDateFrom(newDate);

    // Always auto-set dateTo to 12 months from dateFrom when dateFrom changes
    if (newDate && newDate.isValid()) {
      const newDateTo = newDate.add(12, 'months');
      setDateTo(newDateTo);
    }
  };

  const handleDateToChange = (newDate) => {
    // No validation here - just set the date
    setDateTo(newDate);
  };

  // Add validation function that will be called when Get Data button is clicked
  const validateDateRange = (fromDate, toDate) => {
    if (!fromDate || !toDate) {
      toast.error('Please select both From Date and To Date');
      return false;
    }

    if (!fromDate.isValid() || !toDate.isValid()) {
      toast.error('Please enter valid dates');
      return false;
    }

    const monthsDiff = toDate.diff(fromDate, 'month');

    if (monthsDiff < 0) {
      toast.error('To Date cannot be earlier than From Date');
      return false;
    }

    if (monthsDiff > 12) {
      toast.error('Date range cannot exceed 12 months');
      return false;
    }
    return true;
  };

  const filteredRows = React.useMemo(() => {
    return rows.filter(row => {
      return Object.entries(searchTerms).every(([columnId, term]) => {
        if (!term) return true;
        const value = row[columnId];
        return String(value).toLowerCase().includes(term.toLowerCase());
      });
    });
  }, [searchTerms, rows]);

  const renderCell = (value) => {
    if (!value && value !== '') return '';

    const style = getMonthStyle(value);
    return (
      <div style={style}>
        {value}
      </div>
    );
  };

  const formattedRows = React.useMemo(() => {
    return rows.map(row => {
      const newRow = { ...row };

      Object.keys(row).forEach(key => {
        if (!BASE_COLUMNS.find(col => col.id === key) && row[key] !== undefined) {
          newRow[key] = renderCell(row[key]);
        }
      });

      return newRow;
    });
  }, [rows]);

  const Filters = (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 1 }}>
        <FormControl sx={{ minWidth: 170 }}>
          <InputLabel id="property-select-label">Property</InputLabel>
          <Select
            labelId="property-select-label"
            value={selectedProperty || ''}
            onChange={handleDropdownChange}
            label="Property"
            sx={{ height: "40px" }}
          >
            {properties.map((item) => ( // Use Redux properties
              <MenuItem key={item.Id} value={item.Id}>{item.Name}</MenuItem>
            ))}
          </Select>
        </FormControl>

        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, }}>
            <DatePicker
              label="From-Date"
              value={dateFrom}
              onChange={handleDateFromChange} // Use the new handler
              format="MM/YYYY"
              views={['month', 'year']}
              sx={{ backgroundColor: "white", width: 130 }}
            />
            <DatePicker
              label="To-Date"
              value={dateTo}
              onChange={handleDateToChange} // Use the new handler
              format="MM/YYYY"
              views={['month', 'year']}
              minDate={dateFrom} // Prevent selecting date before dateFrom
              maxDate={dateFrom ? dateFrom.add(12, 'months') : null} // Limit to 12 months from dateFrom
              sx={{ backgroundColor: "white", width: 130 }}
            />
          </Box>
        </LocalizationProvider>
        <Button
          variant="contained"
          onClick={() => { fetchData("") }}
          sx={{ height: "40px", whiteSpace: "nowrap", backgroundColor: "#635bff" }}
        >
          Get Data
        </Button>

        {!isEditMode ? (
          <>
            <Button
              variant="contained"
              onClick={() => setIsEditMode(true)}
              disabled={selectedRoomBedIds.length === 0 || permissions?.EditRec !== "1"}
              startIcon={<EditIcon />}
              sx={{
                height: "40px",
                whiteSpace: "nowrap",
                backgroundColor: "#635bff",
                "&:disabled": {
                  backgroundColor: "rgba(0, 0, 0, 0.12)",
                  color: "rgba(0, 0, 0, 0.26)",
                  boxShadow: "none",
                }
              }}
            >
              Edit
            </Button>

            {selectedRoomBedIds.length > 0 ? (
              <Button
                variant="contained"
                onClick={handleDeleteSelected}
                disabled={permissions?.DeleteRec !== "1"}
                startIcon={<DeleteIcon />}
                sx={{
                  height: "40px",
                  whiteSpace: "nowrap",
                  backgroundColor: "#635bff",
                  "&:disabled": {
                    backgroundColor: "rgba(0, 0, 0, 0.12)",
                    color: "rgba(0, 0, 0, 0.26)",
                    boxShadow: "none",
                  }
                }}
              >
                Delete
              </Button>
            ) : (
              <Button
                variant="contained"
                onClick={handldelete}
                disabled={permissions?.DeleteRec !== "1"}
                startIcon={<DeleteIcon />}
                sx={{
                  height: "40px",
                  whiteSpace: "nowrap",
                  backgroundColor: "#635bff",
                  "&:disabled": {
                    backgroundColor: "rgba(0, 0, 0, 0.12)",
                    color: "rgba(0, 0, 0, 0.26)",
                    boxShadow: "none",
                  }
                }}
              >
                Delete
              </Button>
            )}
          </>
        ) : (
          <>
            <Button
              variant="contained"
              onClick={handleSave}
              startIcon={<Save />}
              sx={{ height: "40px", whiteSpace: "nowrap", backgroundColor: "#635bff" }}
            >
              Save
            </Button>
            <Button
              variant="outlined"
              onClick={handleCancel}
              sx={{ height: "40px", whiteSpace: "nowrap", backgroundColor: "#635bff", color: "white" }}
            >
              Cancel
            </Button>
          </>
        )}
      </Box>
    </Box>
  );

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleClick = () => {
    // navigate('/room-master');
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setForm((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleHomeClick = () => {
    navigate('/dashboard');
  };

  const handleLocationclick = () => {
    navigate('/masters/property');
  };

  const handleRowDoubleClick = () => {
    // console.log("hello")
  };

  return (
    <>
      <Box sx={{ maxWidth: "100vw", overflowX: "hidden" }}>
        <TableComponent
          page={page}
          columns={tableColumns}
          rows={formattedRows}
          title="Property"
          titleMaster="Calender"
          onCancel={handleCancel}
          handleClick={handleClick}
          handleDeleteClick={handleDeleteSelected}
          FiltersJsx={Filters}
          filteredRows={filteredRows}
          // rowsPerPage={rowsPerPage}
          handleSearchChange={handleSearchChange}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={(e) => setRowsPerPage(+e.target.value)}
          handleRowDoubleClick={handleRowDoubleClick}
          handleLocationclick={handleLocationclick}
          handleHomeClick={handleHomeClick}
          rowStyle={(row) => row.style}
          cellStyle={(columnId) =>
            columnId.startsWith('year_') || columnId.match(/^\d+_.+/)
              ? { padding: '0px', fontSize: '12px', textAlign: 'center' }
              : {}
          }
          isEditMode={isEditMode}
          searchTerms={searchTerms}
          pagination={pagination}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
          rowsPerPage={pagination.pageSize}
          setIsEditMode={setIsEditMode}
          selectedRoomBedIds={selectedRoomBedIds}
          setSelectedRoomBedIds={setSelectedRoomBedIds}
          onCellEdit={handleCellEdit}
          onSave={handleSave}
          editable={permissions?.EditRec === "1"}
          isLoading={isLoading}
        />
      </Box>

      {/* <Box sx={{ display: "flex", mx: 9, mb: 2, gap: 2, alignItems: "center" }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Box sx={{ width: 16, height: 16, backgroundColor: "#046A38", borderRadius: "4px" }}></Box>
          <Typography variant="body2">A - Available</Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Box sx={{ width: 16, height: 16, backgroundColor: "#635bff", borderRadius: "4px" }}></Box>
          <Typography variant="body2">B - Booked</Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Box sx={{ width: 16, height: 16, backgroundColor: "#c971bb", borderRadius: "4px" }}></Box>
          <Typography variant="body2">C - Confirm</Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Box sx={{ width: 16, height: 16, backgroundColor: "#FF671F", border: "1px solid black", borderRadius: "4px" }}></Box>
          <Typography variant="body2">P - Partial Booking</Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Box sx={{ width: 16, height: 16, backgroundColor: "#800000", border: "1px solid black", borderRadius: "4px" }}></Box>
          <Typography variant="body2">M - Maintenince</Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Box sx={{ width: 16, height: 16, backgroundColor: "#47a1ba", border: "1px solid black", borderRadius: "4px" }}></Box>
          <Typography variant="body2">R - Reserved</Typography>
        </Box>
      </Box> */}

    </>
  );
}    